import React from "react";
import Input from "@cs/components/src/Input";
import Label from "@cs/components/src/Label";
import { styled } from "styled-components";
import Select from "@cs/components/src/Select";
import ListInput from "@cs/components/src/ListInput";
// import { newWebhookQuery, newWebhookQueryTerm } from './utils';

interface Props {
  pluginConfig?: PluginConfigItem;
  value: WebhookConfigQuery;
  onChange: (value: WebhookConfigQuery) => void;
  odd?: boolean;
  topLevel?: boolean;
}

const Container = styled.div<{ $odd?: boolean; $topLevel?: boolean }>`
  flex-grow: 1;
  background-color: var(${(props) => (props.$odd ? "--dark500" : "--dark100")});
  padding: ${(props) => (props.$topLevel ? "0 0 1px" : "10px 15px 0")};
  margin-bottom: 5px;
`;

const Row = styled.div<{ $columns: string }>`
  display: grid;
  grid-template-columns: ${(props) => props.$columns};
  column-gap: 10px;

  > * {
    margin-bottom: 10px;
  }
`;

const ListWrapper = styled.div`
  > * {
    margin-bottom: 10px;
  }
`;

const booleanOperatorOptions = ["AND", "OR"].map((label) => ({
  label,
  value: label.toLowerCase(),
}));

const compareOperatorOptions = [
  {
    value: "==",
    label: "Equals",
  },
  {
    value: "contain",
    label: "Contains",
  },
  {
    value: "exist",
    label: "Exists",
  },
  {
    value: "has_key",
    label: "Has Key",
  },
  {
    value: "!=",
    label: "Not equal",
  },
  {
    value: "not_contain",
    label: "Not contains",
  },
  {
    value: "not_exist",
    label: "Not exists",
  },
];

const dataTypeOptions = ["Variable", "Text"].map((label) => ({
  label,
  value: label.toLowerCase(),
}));

const TermInput = (props: {
  value: WebhookConfigQueryTerm | WebhookConfigQuery;
  onChange: (value: WebhookConfigQueryTerm | WebhookConfigQuery) => void;
  odd?: boolean;
  pluginConfig?: PluginConfigItem;
}) => {
  const { value, onChange, odd, pluginConfig } = props;
  const update = (key: keyof WebhookConfigQueryTerm) => (v: unknown) => {
    onChange({
      ...value,
      [key]: v,
    });
  };
  const variables = pluginConfig?.variables.map((variable) => ({
    label: variable.title,
    value: variable.id ?? variable.key,
  }));

  if (!("terms" in value)) {
    return (
      <Container $odd={odd}>
        <Row $columns="1fr 160px">
          <Input
            label="Webhook Field"
            value={value.field}
            onChange={update("field")}
          />
          <Select
            label="Operator"
            options={compareOperatorOptions}
            value={value.operator}
            onChange={({ value }) => update("operator")(value)}
          />
        </Row>
        {!value.operator.includes("exist") && (
          <Row $columns="120px 1fr">
            <>
              <Select
                label="Data Type"
                options={dataTypeOptions}
                value={value.dataType}
                onChange={({ value }) => update("dataType")(value)}
              />
              {value.dataType === "variable" ? (
                <Select
                  label="Variable"
                  options={variables}
                  value={value.variableConfigId}
                  onChange={({ value }) => update("variableConfigId")(value)}
                />
              ) : (
                <Input
                  label="Value"
                  value={value.value ?? ""}
                  onChange={update("value")}
                />
              )}
            </>
          </Row>
        )}
      </Container>
    );
  } else {
    return <WebhookQueryInput value={value} onChange={onChange} odd={odd} />;
  }
};

const WebhookQueryInput = (props: Props) => {
  const {
    value: webhookConfigQuery,
    onChange,
    odd,
    pluginConfig,
    topLevel,
  } = props;

  const update = (key: keyof WebhookConfigQuery) => (value: unknown) => {
    onChange({
      ...webhookConfigQuery,
      [key]: value,
    });
  };

  return (
    <>
      {topLevel && <Label label="Query" />}
      <Container $odd={odd} $topLevel={topLevel}>
        <ListWrapper>
          <ListInput
            component={TermInput}
            extraProps={{
              odd: !odd,
              pluginConfig,
            }}
            value={webhookConfigQuery.terms}
            onChange={update("terms")}
            buttons={
              <>
                <Select
                  options={booleanOperatorOptions}
                  value={webhookConfigQuery.operator}
                  onChange={({ value }) => update("operator")(value)}
                />
                {/* <Button
                  label={`Term`}
                  icon={Plus}
                  type="success"
                  onClick={() => {
                    update('terms')([...webhookConfigQuery.terms, newWebhookQueryTerm()]);
                  }}
                />
                <Button
                  label={`Group`}
                  icon={Plus}
                  type="success"
                  onClick={() => {
                    update('terms')([...webhookConfigQuery.terms, newWebhookQuery()]);
                  }}
                /> */}
              </>
            }
          />
        </ListWrapper>
        {/* <Input
        label={
          <>
            <span>Query</span>
            <DocLink
              href="https://app.iconik.io/help/pages/entities/webhooks#webhook-query"
              target="_blank"
              rel="noreferrer"
              tabIndex={-1}
            >
              - Documentation
            </DocLink>
          </>
        }
        value={oddt.query}
        onChange={update('query')}
        textarea
      /> */}
        {}
        {/* <Description>
        {
          'You can reference Plugin Variables using the syntax ${variableKey}. Be sure to wrap strings in double quotes.'
        }
      </Description> */}
      </Container>
    </>
  );
};

export default WebhookQueryInput;
